import * as React from 'react';
import { Box } from '@mui/material';
import Loading from '../loading';
import MapDetail from './mapDetail';
import { options } from '@config';


interface Props {
    ubication: string;
    height: string;
    width: string;
    zoom: number;
}

const MapContainer = (props: Props) => {
    const [items, setItems] = React.useState([]);
    const [loading, setLoading] = React.useState(true); 


    const handleListPoints = async () => {
        const response = await fetch((options.api.url + "point"), {
            method: 'GET',
            mode: "cors",
            headers: {
                'Content-Type': 'application/json'
            },
        });
    
        const data = await response.json();

        const items =  data.pointsSearched

        return items
    }

    React.useEffect(()=> {
        const db = handleListPoints().then((e) => {
            setItems(e);
            setLoading(false);
        });
    },[loading]);

    return (
        <Box>
            {loading ? <Loading/>: <MapDetail dataPoints={items} ubication = {props.ubication} height={props.height} width= {props.width} zoom={props.zoom}/>}
        </Box>
    )
}

export default MapContainer;